// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"329":"53ee4c70","493":"08727ad3"}[chunkId] + ".chunk.css";
};